import React from 'react';
import './PillButton.css';

const PillButton = ({
  children,
  href,
  target,
  rel,
  type = 'button',
  disabled = false,
  loading = false,
  emphasized = false,
  className = '',
  onClick,
  ...props
}) => {
  const isLink = Boolean(href);
  const isDisabled = disabled || loading;
  const classes = [
    'pill-button',
    emphasized ? 'pill-button--emphasized' : '',
    isDisabled ? 'pill-button--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (isLink) {
    return (
      <a
        className={classes}
        href={isDisabled ? undefined : href}
        target={target}
        rel={rel}
        aria-disabled={isDisabled ? 'true' : 'false'}
        onClick={isDisabled ? (e) => e.preventDefault() : onClick}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      disabled={isDisabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default PillButton;
